export default __webpack_public_path__ + "static/media/consulta-agendamento.eca667ba.png";